import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandingService {

  constructor(private http: HttpClient) { }

  public getLogo(): Observable<any> {
    return this.http.get(environment.serviceurl + '/Branding/Logo');
  }

  public uploadLogo(formData: FormData): Observable<any> {
    const par: HttpParams = new HttpParams().set('multiPartData', '1');
    return this.http.post(environment.serviceurl + '/Branding/Logo', formData, { params: par });
  }

  public deleteLogo(): Observable<any> {
    return this.http.delete(environment.serviceurl + '/Branding/Logo');
  }
}
